import { render, staticRenderFns } from "./BehaviourWeeklyBreakdown.vue?vue&type=template&id=b66a4fac&scoped=true&"
import script from "./BehaviourWeeklyBreakdown.vue?vue&type=script&lang=js&"
export * from "./BehaviourWeeklyBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourWeeklyBreakdown.vue?vue&type=style&index=0&id=b66a4fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66a4fac",
  null
  
)

export default component.exports